import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExercicioListComponent } from './exercicio-list/exercicio-list.component';
import { AuthGuard } from '../util/auth.guard';

const routes: Routes = [
  { path: '', component: ExercicioListComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExercicioRoutingModule { }
